import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackViewedOnboardingJobTitle.meta';

export const useTrackViewedOnboardingJobTitle = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedOnboardingJobTitle = useCallback(() => {
    track(META.name, undefined, { integrations: { Intercom: true } });
  }, [track]);

  return { trackViewedOnboardingJobTitle };
};
